import { render, staticRenderFns } from "./AddRoleModal.vue?vue&type=template&id=3d5432d3&scoped=true&"
import script from "./AddRoleModal.vue?vue&type=script&lang=js&"
export * from "./AddRoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5432d3",
  null
  
)

export default component.exports